module.exports = __webpack_public_path__ + "static/media/truck-ramp.06617ddf.svg";